import { useEffect, useRef, useState } from 'react';
import api from '../api';

// Хук возвращает текущие issues для переданного value (с debounce).
// issues = [{word, offset, length, suggestions}]
export default function useSpellCheck(value, { delay = 500, enabled = true } = {}) {
  const [issues, setIssues] = useState([]);
  const seqRef = useRef(0);
  const timerRef = useRef(null);

  useEffect(() => {
    if (!enabled || !value || value.trim().length < 2) {
      setIssues([]);
      return;
    }
    if (timerRef.current) clearTimeout(timerRef.current);
    const mySeq = ++seqRef.current;
    timerRef.current = setTimeout(async () => {
      try {
        const res = await api.post('/spellcheck/check', { text: value });
        // Игнорируем устаревшие ответы (если пришёл новый запрос позже)
        if (mySeq !== seqRef.current) return;
        setIssues(res.data.issues || []);
      } catch (e) {
        // 429 / сеть — молча сбрасываем
        if (mySeq === seqRef.current) setIssues([]);
      }
    }, delay);
    return () => { if (timerRef.current) clearTimeout(timerRef.current); };
  }, [value, delay, enabled]);

  return issues;
}
